export default {
  data: null,
  filters : null
};
